import CloseButton from "Components/Common/CloseButton";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom";
import { Offcanvas, OffcanvasBody } from "reactstrap"
import { fetchCampaignPayments } from "slices/campaigns/payments/thunk";
import { togglePaymentsOffcanvas } from "slices/ui/reducer";
import { AppDispatch, RootState } from "store"
import userProfilePicture from "../../assets/images/users/user-dummy-img.jpg"

const CampaignPaymentsOffcanvas = () => {

    const { campaignId } = useParams();

    const campaignPaymentsOffcanvasVisibility = useSelector((state: RootState) => state.ui.paymentsOffcanvas);
    const dispatch: AppDispatch = useDispatch();

    const campaignPaymentData = useSelector((state: RootState) => state.campaignPayments.campaigns[campaignId!]);

    const payments = campaignPaymentData?.items ?? [];
    const totalPaid = campaignPaymentData?.total ?? 0;

    const paymentTypes = campaignPaymentData?.types ?? {};


    useEffect(() => {
        if (campaignPaymentsOffcanvasVisibility && campaignId) {
            dispatch(fetchCampaignPayments({ campaignId }));
        }
    }, [campaignPaymentsOffcanvasVisibility, campaignId])



    return (
        <Offcanvas
            isOpen={campaignPaymentsOffcanvasVisibility}
            direction="end"
            className="campaign-payments-offcanvas"
            toggle={() => dispatch(togglePaymentsOffcanvas(false))}
        >
            <CloseButton onClose={() => dispatch(togglePaymentsOffcanvas(false))} />
            <OffcanvasBody className="m-0 p-0 position-relative">
                <div className="payments-offcanvas-bg"></div>
                <div className="payments-offcanvas mt-2 py-4 px-4">
                    <div className="payments-offcanvas-header">
                        <h2>Payments History</h2>
                    </div>
                    <div className="payments-offcanvas-content mt-4">
                        {
                            payments.map((payment, i) => {
                                return (
                                    <div className="payment-card d-flex justify-content-between align-items-center gap-3 flex-column flex-lg-row gap-2 gap-lg-0" key={i}>
                                        <div className="d-flex justify-content-start align-items-center gap-3 flex-grow">
                                            <img src={payment.influencer?.profile_picture_url ?? userProfilePicture} alt="Profile" />
                                            <div className="d-flex flex-column gap-2">
                                                <span className="receiver-name">{payment.influencer.name}</span>
                                                <div className="d-flex flex-wrap gap-1">
                                                    <span className="badge">📅 {payment.paid}</span>
                                                    <span className="badge">💰 {paymentTypes[payment.type]}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-end flex-row flex-lg-column px-3 gap-2 py-2 py-lg-0">
                                            <span className="payment-amount">₹{payment.amount}</span>
                                            <span className="payment-label">Amount Paid</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {
                            payments.length === 0 &&
                            <div className="d-flex w-100 justify-content-center align-items-center no-payments">
                                <h3 className="empty-msg">No payment processed yet!</h3>
                            </div>
                        }
                    </div>
                </div>
                <div className="payments-offcanvas-footer d-flex justify-content-end align-items-center px-2 gap-2">
                    <span className="payment-label">Total Amount Paid</span>
                    <span className="payment-amount">₹{totalPaid}</span>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    )
}

export default CampaignPaymentsOffcanvas